/**
 * Attribution association — mémorise le lien de partage `?asso=<ID>` cliqué par
 * un adhérent, pour pré-sélectionner l'association au moment de publier ET
 * attribuer le vendeur à l'association qui l'a amené, même s'il explore le
 * site avant de vendre.
 *
 * Le paramètre `?asso=` n'est présent que sur le chargement INITIAL (clic sur
 * le lien de l'asso). On le capture une fois et on le persiste (localStorage,
 * 30 jours) ; ensuite il survit à toute la navigation dans la SPA.
 */
const KEY = "gively_ref_asso";
const TTL_MS = 30 * 24 * 3600 * 1000; // 30 jours

export function captureAssoReferralFromUrl() {
  try {
    const id = new URLSearchParams(window.location.search).get("asso");
    if (id) {
      window.localStorage.setItem(KEY, JSON.stringify({ id, ts: Date.now() }));
    }
  } catch (_) {
    /* localStorage indisponible (mode privé strict) — silencieux */
  }
}

export function getAssoReferral() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const { id, ts } = JSON.parse(raw);
    if (!id || !ts || Date.now() - ts > TTL_MS) {
      clearAssoReferral();
      return null;
    }
    return id;
  } catch (_) {
    return null;
  }
}

export function clearAssoReferral() {
  try {
    window.localStorage.removeItem(KEY);
  } catch (_) {
    /* silencieux */
  }
}
